import {PushpinOutlined} from '@ant-design/icons'
import {useMapContext} from '@/components/MindMap/index.mjs'
import IconWithNotification from '../IconWithNotification.jsx'
import MarkedNodes from './MarkedNodes.jsx'

export default () => {
    const map = useMapContext()
    const nodes = [...map.useMarkedNodes()]

    return {
        icon: (
            <IconWithNotification notification={0 < nodes.length}>
                <PushpinOutlined />
            </IconWithNotification>
        ),

        key: 'mark',
        name: '标记',
        pane: <MarkedNodes nodes={nodes} />,
    }
}
